import { render, staticRenderFns } from "./PlatformSubscriptionCard.vue?vue&type=template&id=42d38fc7&"
import script from "./PlatformSubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./PlatformSubscriptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports